module.exports = __webpack_public_path__ + "media/images/tmp/avatar-99ab0cbd53825ea072f02b11be607568.jpg";